export class HashManager {
    static instance = null;

    static getInstance() {
        if (!HashManager.instance) {
            HashManager.instance = new HashManager();
        }
        return HashManager.instance;
    }

    constructor() {
        this.state = this.parseHash();
        this.jumper();

        window.addEventListener('popstate', (event) => {
            this.state = event.state !== null ? event.state : this.parseHash();
        });

        window.addEventListener('hashchange', () => {
            this.state = this.parseHash();
        });
    }

    jumper() {
        if ('jump' in this.state) {
            const element = document.getElementById(this.state.jump);
            if (element) {
                const rootStyles = getComputedStyle(document.documentElement);
                let headerHeight = rootStyles.getPropertyValue('--site-header-height').trim();
                headerHeight = parseInt(headerHeight.replace('px', '')) || 0;
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                const scrollToPosition = elementPosition - headerHeight;
                // setTimeout(() => {
                //     window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
                // }, 50);
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }

    parseHash() {
        const hash = window.location.hash.substring(1);
        if (!hash) return {};

        const state = {};
        hash.split('&').forEach(pair => {
            if (!pair) return;
            const [key, value] = pair.split('=').map(decodeURIComponent);
            if (!key) return;

            if (!value) {
                state[key] = true;
            } else if (value.includes(',')) {
                state[key] = value.split(',').map(decodeURIComponent);
            } else {
                state[key] = value;
            }
        });
        return state;
    }

    updateState(newState) {
        Object.keys(newState).forEach(key => {
            if (newState[key] === false || newState[key] === undefined || newState[key] === null) {
                delete this.state[key];
            } else {
                this.state[key] = newState[key];
            }
        });
        this.updateHash();
    }

    updateHash() {
        const hashes = [];
        Object.entries(this.state).filter(([key, value]) => key !== '!').forEach(([key, value]) => {
            if (typeof value === 'boolean' && value) {
                hashes.push(encodeURIComponent(key));
            } else if (typeof value === 'string') {
                hashes.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            } else if (Array.isArray(value)) {
                hashes.push(`${encodeURIComponent(key)}=${value.map(v => encodeURIComponent(v)).join(',')}`);
            }
        });
        // history.pushState(this.state, '', `#${hashes.join('&')}`);
        const hash = hashes.length > 0 ? hashes.join('&') : '';
        if (hash === '') {
            history.replaceState(null, '', window.location.pathname + window.location.search);
        } else {
            window.location.hash = hash;
        }
    }

    getState() {
        return { ...this.state };
    }
}

window.HashManager = HashManager.getInstance();